import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { RoleResponseModel } from "src/app/model/RoleResponseModel";
import { FeatureForRoleResponse } from "src/app/model/FeatureForRoleResponse";

@Component({
  selector: "app-secure-role-au",
  templateUrl: "./role-au.component.html",
  styleUrls: ["./role-au.component.scss"],
})
export class RoleAUComponent implements OnInit {
  roleKey: number;
  pageMode: string;
  roleModel : RoleResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  roleTypes: string[];
  screenFeatures: FeatureForRoleResponse[];

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.masterService
    .initRoleForm()
    .subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.roleTypes = data.roleTypes;
        this.screenFeatures = data.features;
      }
      else {
        this.errorToast(data.errorMessage, 5*1000);
      }
      this.route.params.subscribe((params: Params) => {
        this.roleKey = +params["key"];      
        if(this.roleKey) {
          this.masterService
          .getRoleBykey(this.roleKey)
          .subscribe((data: any) => {
            this.roleModel = data;
            this.pageMode = "Edit";
            this.form.patchValue({
              roleType: this.roleModel.roleName,
            });
            let selectedFeatures: FormArray = this.form.get('features') as FormArray;
            this.roleModel.features.forEach(rf => {
              selectedFeatures.push(new FormControl(rf));
            });
          });
        }
        else {
          this.pageMode = "Add";
        }
      });
    });
    this.form = new FormGroup({
      roleType: new FormControl(null, Validators.required),
      features: new FormArray([])
    });
  }

  onSubmit() {
    if(this.pageMode === 'Add') {
      this.save();
    }
    else {
      this.update();
    }
  }

  async save() {
    if (this.form.valid) {
      this.masterService
      .saveRole({
        roleType: this.form.value.roleType,
        featureIds: this.form.value.features
      })
      .subscribe((data: any) => {
          if(data.status === 'SUCCESS') {
            this.successToast();
            this.router.navigate(["/secure", "master", "role", "list"]);
          }
          else {
            this.isSubmitDisabled = false;
            this.errorToast(data.errorMessage);
          }
        }, error => {
          this.isSubmitDisabled = false;
          console.log(error);
          this.errorToast(error.error.errorMessage, 5*1000);
        });
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("");
    }
  }

  async update() {
    if (this.form.valid) {
      this.masterService
      .updateRole(this.roleKey, {
        roleType: this.form.value.roleType,
        featureIds: this.form.value.features
      }).subscribe((data: any) => {
        if(data.status === 'SUCCESS') {
          this.successToast();
          this.router.navigate(["/secure", "master", "role", "list"]);
        }
        else {
          this.isSubmitDisabled = false;
          this.errorToast(data.errorMessage);
        }
      }, error => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5*1000);
      });
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("");
    }
  }

  async successToast() {
    await this._snackBar.open(
      "Role saved successfully.",
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  showRoleType(o1: any, o2: any) {
    console.log(o1, o2, o1 == o2);
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }

  onCheckboxChange(e: any) {
    const selectedFeatures: FormArray = this.form.get('features') as FormArray;
    if (e.target.checked) {
      selectedFeatures.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      selectedFeatures.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          selectedFeatures.removeAt(i);
          return;
        }
        i++;
      });
    }
  }
}